import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

const fieldId = 'power-supply'

const PowerSupplyField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item',
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id={fieldId}
        propertyName='powerSupply'
        placeholder=''
        label={<span>{t(`wizard.screen.otherFacilities.powerSupply`, 'Power supply')}</span>}
        value={insertionData.powerSupply}
        maxLength={12}
        type='text'
        affixRight='unit'
        unitRight='kiloVoltAmpere'
        errors={validationMessages?.powerSupply ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default PowerSupplyField
